import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

/**
 * Gets an instance of the translate http loader.
 *
 * It will be used as a value for the translate module token.
 *
 * @see https://github.com/ngx-translate/http-loader#usage
 * @example imports: [
 *            TranslateModule.forRoot({
 *              loader: {
 *                 provide: TranslateLoader,
 *                 useFactory: BydTranslateLoaderFactory, // here goes the BydTranslateLoaderFactory
 *                 deps: [HttpClient],
 *               },
 *              }),
 *            ],
 * @param httpClient HttpClient to perform HTTP requests.
 * @returns TranslateHttpLoader
 */
export function BydTranslateLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
